function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.number.is-integer.js";
import "core-js/modules/es.number.parse-float.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/* Styles */
import "../../../style/widgets/trend_widget.css";
/* JS */
import axios from "axios";
//@ts-ignore
import { handleAxiosError } from "@services/servicesUtils";
//@ts-ignore
import { rgba } from "@utils/ColorsUtils";
//@ts-ignore
import { formatInteger, formatFloat } from "@utils/NumberUtils";
import { Chart, LineController, LinearScale, TimeScale, PointElement, LineElement, Filler, Tooltip, CategoryScale } from "chart.js";
import "chartjs-adapter-date-fns";
//@ts-ignore
import { sendGAevent, sendMessageEvent } from "@wkWebSrc/js/widgets/widget_ga_event";
//@ts-ignore
import { COLORS, MAP_TILER_APIKEY } from "../../components/variables";
// @ts-ignore
import { getCityPolygonJSON, getCountryPolygonJSON, getProvincePolygonJSON, getRegionPolygonJSON
//@ts-ignore
} from "@services/geographyAPI";
var parser = require("wellknown");
Chart.register(LineController, LinearScale, TimeScale, PointElement, LineElement, Filler, Tooltip, CategoryScale);
import { it, de, enUS } from "date-fns/locale";
// @ts-ignore
import { PLACE_TYPE } from "@customTypes/PlaceType";
var PERIOD;
(function (PERIOD) {
  PERIOD[PERIOD["ALL"] = 0] = "ALL";
  PERIOD[PERIOD["THREE_MONTHS"] = 3] = "THREE_MONTHS";
  PERIOD[PERIOD["SIX_MONTHS"] = 6] = "SIX_MONTHS";
  PERIOD[PERIOD["ONE_YEAR"] = 12] = "ONE_YEAR";
})(PERIOD || (PERIOD = {}));
export var drawingOptions = {
  color: "#f0f0f0",
  fillOpacity: 0.7,
  weight: 2
};
export var DEF_COLOR = "#BFBFBF";
export var FILL_COLORS = {
  0: "#5e8e24",
  1: "#76B22E",
  2: "#92d049",
  3: "#ffba08",
  4: "#de7e33",
  5: "#d7263d"
};
var L;
var TrendWidget = {
  placeLabel: "Italia",
  placeURL: "",
  italyPlaceString: "nazione-italia",
  graphMap: {
    "sale": [],
    "rent": []
  },
  loading: true,
  sale: window["_widgetSale"],
  chart: null,
  showEuros: true,
  colors: {
    start: hexToRGB(window["_customColor"], 1),
    quarter: hexToRGB(window["_customColor"], 0.25),
    finish: hexToRGB(window["_customColor"], 0)
  },
  showTrendMap: window["_showTrendMap"],
  showBack: window["_showBack"],
  period: PERIOD.ALL,
  averagePrice: null,
  locale: window["_lang"] || "it",
  place: JSON.parse(window["_serializedPlace"]),
  averagePricePlace: JSON.parse(window["_serializedAveragePricesForMap"]),
  averagePrices: JSON.parse(window["_averagePrices"]),
  averagePricesMap: {},
  averagePricesMapRent: {},
  placesList: {},
  hasZones: window["_hasZones"],
  map: null,
  minAvg: 0,
  maxAvg: 0,
  minAvgRent: 0,
  maxAvgRent: 0,
  priceLayers: [],
  priceLayersRent: [],
  clickLayers: [],
  clickLayersRent: [],
  getSaleRentAveragePriceGraphData: function getSaleRentAveragePriceGraphData() {
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var restURL, res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            restURL = "/rest/statistics/getSaleRentAveragePriceGraphData/".concat(this.placeURL || this.italyPlaceString, "/1");
            _context.next = 4;
            return axios.post(restURL);
          case 4:
            res = _context.sent;
            return _context.abrupt("return", res.data);
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            handleAxiosError(_context.t0);
            console.error("getSaleRentAveragePriceGraphData failed due to " + _context.t0);
            throw _context.t0;
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, this, [[0, 8]]);
    }));
  },
  updateSaleRentAveragePriceGraphData: function updateSaleRentAveragePriceGraphData() {
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return this.getSaleRentAveragePriceGraphData();
          case 2:
            this.graphMap = _context2.sent;
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
  },
  mounted: function mounted() {
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return this.updateSaleRentAveragePriceGraphData();
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
  },
  created: function created() {
    this.placeURL = new URLSearchParams(window.location.search).get("placeURL") || "";
    sendGAevent("TREND_WIDGET_EMBEDDED", {
      place: window["_place"] || ""
    });
    sendMessageEvent("TREND_WIDGET_EMBEDDED", {
      place: window["_place"] || ""
    });
    if (this.showTrendMap) {
      var widgetSelectors = document.getElementsByClassName("widget-part-container");
      for (var i = 0; i < widgetSelectors.length; i++) {
        widgetSelectors.item(i).classList.add("w-50");
      }
    }
  },
  showedData: function showedData() {
    var data = this.sale ? this.graphMap.sale : this.graphMap.rent;
    return this.period == PERIOD.ALL ? data : data.slice(-1 * this.period.valueOf());
  },
  labels: function labels() {
    return this.showedData().map(function (data) {
      return data.label;
    });
  },
  values: function values() {
    return this.showedData().map(function (data) {
      return data.value;
    });
  },
  isRegion: function isRegion() {
    return this.place.placeType == PLACE_TYPE.REGION;
  },
  isCountry: function isCountry() {
    return this.place.placeType == PLACE_TYPE.NATION;
  },
  getGradient: function getGradient() {
    var cx = document.getElementById("trend-widget-external").getContext("2d");
    //@ts-ignore
    cx.canvas.height = 100;
    var gradient = cx === null || cx === void 0 ? void 0 : cx.createLinearGradient(0, 25, 0, 300);
    gradient === null || gradient === void 0 ? void 0 : gradient.addColorStop(0, this.colors.start);
    gradient === null || gradient === void 0 ? void 0 : gradient.addColorStop(0.4, this.colors.quarter);
    gradient === null || gradient === void 0 ? void 0 : gradient.addColorStop(1, this.colors.finish);
    return gradient;
  },
  chartData: function chartData() {
    return {
      labels: this.labels(),
      datasets: [{
        data: this.values(),
        borderColor: hexToRGB(window["_customColor"], 1),
        backgroundColor: this.getGradient(),
        pointBackgroundColor: "#".concat(window["_customColor"]),
        tension: 0.6,
        fill: true
      }]
    };
  },
  generateChart: function generateChart() {
    var _this = this;
    return new Chart(document.getElementById("trend-widget-external"), {
      type: "line",
      data: this.chartData(),
      options: {
        responsive: true,
        locale: getFullLocaleString(this.locale),
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: false,
            suggestedMin: Math.min.apply(Math, _toConsumableArray(this.showedData().map(function (a) {
              return a.value;
            }))) * 0.95,
            suggestedMax: Math.max.apply(Math, _toConsumableArray(this.showedData().map(function (a) {
              return a.value;
            }))) * 1.05,
            ticks: {
              callback: function callback(value) {
                if (Number.isInteger(value)) return "".concat(formatInteger(parseInt(value)));else return "";
              },
              maxTicksLimit: 10
            },
            title: {
              display: true
            }
          },
          x: {
            type: "time",
            time: {
              tooltipFormat: this.period == PERIOD.ALL ? "MMM yyyy" : "MMM",
              unit: this.period == PERIOD.ALL ? "year" : "month"
            },
            ticks: {
              source: "auto",
              maxTicksLimit: 6
            },
            grid: {
              display: true
            },
            adapters: {
              date: {
                locale: this.locale === "it" ? it : this.locale === "en" ? enUS : de
              }
            }
          }
        },
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            mode: "index",
            intersect: true,
            backgroundColor: hexToRGB(window["_customColor"], 0.9),
            titleColor: rgba("#ffffff", 1),
            bodyColor: rgba("#ffffff", 1),
            cornerRadius: window["_rounded"] ? 10 : 0,
            callbacks: {
              label: function label(context) {
                if (_this.showEuros) {
                  var numberYLabel = +context.parsed.y;
                  if (numberYLabel > 100) {
                    return "".concat(formatInteger(context.parsed.y), " \u20AC/m\xB2");
                  } else {
                    return getDottedString(numberYLabel) + " €/m²";
                  }
                } else return "".concat(formatInteger(context.parsed.y));
              }
            }
          }
        },
        hover: {
          mode: "index",
          intersect: true
        },
        animation: {
          duration: 500
        }
      }
    });
  },
  calcFillColor: function calcFillColor(props) {
    var avg = props.avg,
      min = props.min,
      max = props.max,
      medium = props.medium,
      steps = props.steps;
    if (!avg) return DEF_COLOR;
    var lowerStep = (medium - min) / steps;
    var upperStep = (max - medium) / steps;
    if (avg < medium - lowerStep * 2) return FILL_COLORS[0];
    if (avg < medium - lowerStep) return FILL_COLORS[1];
    if (avg < medium) return FILL_COLORS[2];
    if (avg < medium + upperStep) return FILL_COLORS[3];
    if (avg < medium + upperStep * 2) return FILL_COLORS[4];
    return FILL_COLORS[5];
  },
  buildPopupContent: function buildPopupContent(pricePlace, url) {
    var place = pricePlace.place;
    var popupFragment = document.createDocumentFragment();
    // eslint-disable-next-line max-len
    popupFragment.append("<p class=\"font-weight-bold mb-10\">".concat(this.isCountry() ? place.regionName : this.isRegion() ? place.provinceName : this.hasZones ? place.zoneName : place.cityName, "</p>"));
    if (!pricePlace.residentialAverageSale && !pricePlace.residentialAverageRent)
      // elem.append(`<p>${_dataNotAvailableLabel}</p>`)
      popupFragment.append("<p>".concat(window["_labels"]["data_not_available"], "</p>"));else {
      if (pricePlace.residentialAverageSale) {
        // eslint-disable-next-line max-len
        popupFragment.append("<p class=\"show-on-sale\">".concat(window["_labels"]["average_price_sale"], " <br /><span class=\"font-weight-bold\">").concat(formatInteger(pricePlace.residentialAverageSale, true), "</span> &euro;/m<sup>2</sup></p>"));
      }
      if (pricePlace.residentialAverageRent) {
        // eslint-disable-next-line max-len
        popupFragment.append("<p class=\"show-on-rent\">".concat(window["_labels"]["average_price_rent"], " <br /><span class=\"font-weight-bold\">").concat(formatFloat(pricePlace.residentialAverageRent), "</span> &euro;/m<sup>2</sup></p>"));
      }
      // eslint-disable-next-line max-len
      popupFragment.append("<a href=\"".concat(url, "\" class=\"text-capitalize font-weight-bold d-block mt-10\">").concat(this.isCountry() ? window["_labels"]["view_region_data"] : this.isRegion() ? window["_labels"]["view_province_data"] : this.hasZones ? window["_labels"]["view_zone_data"] : window["_labels"]["view_data_label"], "</a>"));
    }
    return "<div class=\"p-15 text-center\">".concat(popupFragment.textContent, "</div>");
  },
  initMap: function initMap() {
    var _a, _b;
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var _this2 = this;
      var LeafletModule, leaflet, jsonPolygon, features, urlSearchParams;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            this.averagePrices.forEach(function (price) {
              if (price) {
                // eslint-disable-next-line max-len
                _this2.placesList[_this2.isCountry() ? price.place.regionID : _this2.isRegion() ? price.place.provinceID : _this2.hasZones ? price.place.zoneID : price.place.cityID] = price;
                // eslint-disable-next-line max-len
                _this2.averagePricesMap[_this2.isCountry() ? price.place.regionID : _this2.isRegion() ? price.place.provinceID : _this2.hasZones ? price.place.zoneID : price.place.cityID] = price.residentialAverageSale;
                if (!_this2.minAvg && price.residentialAverageSale) _this2.minAvg = price.residentialAverageSale;
                if (!_this2.maxAvg && price.residentialAverageSale) _this2.maxAvg = price.residentialAverageSale;
                if (price.residentialAverageSale && price.residentialAverageSale < _this2.minAvg) trendWidget.minAvg = price.residentialAverageSale;
                if (price.residentialAverageSale && price.residentialAverageSale > _this2.maxAvg) _this2.maxAvg = price.residentialAverageSale;
                // placesList[isCountry() ? price.place.regionID : isRegion() ? price.place.provinceID : this.hasZones ? price.place.zoneID : price.place.cityID] = price;
                // eslint-disable-next-line max-len
                _this2.averagePricesMapRent[_this2.isCountry() ? price.place.regionID : _this2.isRegion() ? price.place.provinceID : _this2.hasZones ? price.place.zoneID : price.place.cityID] = price.residentialAverageRent;
                if (!_this2.minAvgRent && price.residentialAverageRent) _this2.minAvgRent = price.residentialAverageRent;
                if (!_this2.maxAvgRent && price.residentialAverageRent) _this2.maxAvgRent = price.residentialAverageRent;
                if (price.residentialAverageRent && price.residentialAverageRent < _this2.minAvgRent) _this2.minAvgRent = price.residentialAverageRent;
                if (price.residentialAverageRent && price.residentialAverageRent > _this2.maxAvgRent) _this2.maxAvgRent = price.residentialAverageRent;
              }
            });
            //@ts-ignore
            _context4.next = 3;
            return import("@wkWebSrc/js/LeafletMap/leaflet_map");
          case 3:
            LeafletModule = _context4.sent;
            leaflet = LeafletModule["default"]; //@ts-ignore
            _context4.next = 7;
            return import( /* webpackChunkName: "chunks/leaflet" */"leaflet/src/Leaflet");
          case 7:
            L = _context4.sent;
            this.map = new leaflet();
            _context4.prev = 9;
            _context4.next = 12;
            return this.showMap();
          case 12:
            if (!this.isCountry()) {
              _context4.next = 18;
              break;
            }
            _context4.next = 15;
            return getCountryPolygonJSON(this.place.countryID);
          case 15:
            _context4.t0 = _context4.sent;
            _context4.next = 35;
            break;
          case 18:
            if (!this.isRegion()) {
              _context4.next = 24;
              break;
            }
            _context4.next = 21;
            return getRegionPolygonJSON(this.place.regionID);
          case 21:
            _context4.t1 = _context4.sent;
            _context4.next = 34;
            break;
          case 24:
            if (!this.hasZones) {
              _context4.next = 30;
              break;
            }
            _context4.next = 27;
            return getCityPolygonJSON(this.place.cityID);
          case 27:
            _context4.t2 = _context4.sent;
            _context4.next = 33;
            break;
          case 30:
            _context4.next = 32;
            return getProvincePolygonJSON(this.place.provinceID);
          case 32:
            _context4.t2 = _context4.sent;
          case 33:
            _context4.t1 = _context4.t2;
          case 34:
            _context4.t0 = _context4.t1;
          case 35:
            jsonPolygon = _context4.t0;
            _context4.next = 41;
            break;
          case 38:
            _context4.prev = 38;
            _context4.t3 = _context4["catch"](9);
            console.error(_context4.t3);
          case 41:
            features = this.isRegion() || this.isCountry() ? JSON.parse(jsonPolygon.polygonList) : jsonPolygon.polygonList;
            urlSearchParams = new URLSearchParams(window.location.search);
            features.forEach(function (feature, i) {
              var p = _this2.placesList[_this2.isCountry() ? feature.regionId : _this2.isRegion() ? feature.provinceId : _this2.hasZones ? feature.zoneId : feature.cityId];
              urlSearchParams.set("placeURL", p.place.urlPartName.replace("_", "-"));
              urlSearchParams.set("widgetShowBack", "true");
              var salePopup = null;
              var rentPopup = null;
              if (p) {
                urlSearchParams.set("widgetSale", "true");
                var url = "".concat(window["_baseURL"], "/").concat(window["_widgetTrendURL"], "/?").concat(urlSearchParams);
                salePopup = L.popup().setContent(_this2.buildPopupContent(p, url));
                urlSearchParams.set("widgetSale", "false");
                url = "".concat(window["_baseURL"], "/").concat(window["_widgetTrendURL"], "/?").concat(urlSearchParams);
                rentPopup = L.popup().setContent(_this2.buildPopupContent(p, url));
              }
              var priceLayerRent = L.geoJSON(parser(feature.polygon), {
                style: function style() {
                  // eslint-disable-next-line max-len
                  var average = _this2.averagePricesMapRent[_this2.isCountry() ? feature.regionId : _this2.isRegion() ? feature.provinceId : _this2.hasZones ? feature.zoneId : feature.cityId];
                  return Object.assign(Object.assign({}, drawingOptions), {
                    fillColor: _this2.calcFillColor({
                      avg: average,
                      medium: _this2.averagePricePlace.residentialAverageRent,
                      min: _this2.minAvgRent,
                      max: _this2.maxAvgRent,
                      steps: 4
                    })
                  });
                }
              }).addTo(_this2.map.getMap());
              var priceLayer = L.geoJSON(parser(feature.polygon), {
                style: function style() {
                  // eslint-disable-next-line max-len
                  var average = _this2.averagePricesMap[_this2.isCountry() ? feature.regionId : _this2.isRegion() ? feature.provinceId : _this2.hasZones ? feature.zoneId : feature.cityId];
                  return Object.assign(Object.assign({}, drawingOptions), {
                    fillColor: _this2.calcFillColor({
                      avg: average,
                      min: _this2.minAvg,
                      max: _this2.maxAvg,
                      medium: _this2.averagePricePlace.residentialAverageSale,
                      steps: 4
                    })
                  });
                }
              }).addTo(_this2.map.getMap());
              if (salePopup) {
                priceLayer.bindPopup(salePopup);
                if (!_this2.isCountry() && !_this2.isRegion() && (_this2.hasZones && _this2.place.zoneID == feature.zoneId || !_this2.hasZones && _this2.place.cityID == feature.cityId)) priceLayer.openPopup();
              }
              if (rentPopup) priceLayerRent.bindPopup(rentPopup);
              _this2.priceLayers.push(priceLayer);
              _this2.priceLayersRent.push(priceLayerRent);
            });
            (_a = document.getElementById("map")) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new Event("init-map-layers"));
            if (this.showBack) {
              (_b = document.getElementById("map-back")) === null || _b === void 0 ? void 0 : _b.classList.remove("d-none");
            }
          case 46:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this, [[9, 38]]);
    }));
  },
  showMap: function showMap() {
    var _a;
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return (_a = this.map) === null || _a === void 0 ? void 0 : _a.init(document.getElementById("map"), MAP_TILER_APIKEY, COLORS, {
              dragging: false,
              maxZoom: this.isCountry() ? 8 : this.place.placeType == PLACE_TYPE.PROVINCE || this.isRegion() ? 12 : 14,
              minZoom: this.isCountry() ? 5 : this.place.placeType == PLACE_TYPE.PROVINCE || this.isRegion() ? 7 : 9
            }, {
              latitude: this.place.latitude,
              longitude: this.place.longitude
            }, this.isCountry() ? 5 : this.isRegion() ? 8 : this.place.placeType == PLACE_TYPE.PROVINCE ? 10 : 11);
          case 3:
            _context5.next = 9;
            break;
          case 5:
            _context5.prev = 5;
            _context5.t0 = _context5["catch"](0);
            console.error(_context5.t0);
            throw new Error(_context5.t0.message);
          case 9:
          case "end":
            return _context5.stop();
        }
      }, _callee5, this, [[0, 5]]);
    }));
  },
  render: function render() {
    var _a, _b, _c, _d, _e;
    if (!this.chart) {
      this.chart = this.generateChart();
    } else {
      this.chart.destroy();
      this.chart = null;
      this.chart = this.generateChart();
    }
    this.averagePrice = getDottedString(this.values().reduce(function (a, b) {
      return a + b;
    }, 0) / this.values().length);
    var contactLabel = this.sale ? window["_labels"]["for_sale"] : window["_labels"]["for_rent"];
    //@ts-ignore
    document.getElementById("average-price").innerText = "".concat(contactLabel, ": ").concat(this.averagePrice, " \u20AC/mq");
    (_a = document.getElementById("loading")) === null || _a === void 0 ? void 0 : _a.classList.remove("d-block");
    (_b = document.getElementById("loading")) === null || _b === void 0 ? void 0 : _b.classList.add("d-none");
    (_c = document.getElementById("trend-widget-main")) === null || _c === void 0 ? void 0 : _c.classList.remove("overflow-hidden");
    (_d = document.getElementById("trend-widget-main")) === null || _d === void 0 ? void 0 : _d.classList.add("overflow-y-auto");
    (_e = document.getElementById("trend-widget-main")) === null || _e === void 0 ? void 0 : _e.classList.add("overflow-x-hidden");
    /* Restore all elements hided during loading */
    var selectors = document.getElementsByClassName("only-loaded-container");
    for (var i = 0; i < selectors.length; i++) {
      selectors.item(i).classList.remove("d-none");
      selectors.item(i).classList.add("d-block");
    }
  }
};
var trendWidget = Object.assign({}, TrendWidget);
document.addEventListener("DOMContentLoaded", function () {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    var _a;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          trendWidget.created();
          _context6.next = 3;
          return trendWidget.mounted();
        case 3:
          trendWidget.render();
          if (!trendWidget.showTrendMap) {
            _context6.next = 8;
            break;
          }
          (_a = document.getElementById("map")) === null || _a === void 0 ? void 0 : _a.addEventListener("init-map-layers", function () {
            var _a, _b;
            if (trendWidget.sale) {
              (_a = document.getElementById("sale-tab")) === null || _a === void 0 ? void 0 : _a.click();
            } else {
              (_b = document.getElementById("rent-tab")) === null || _b === void 0 ? void 0 : _b.click();
            }
          });
          _context6.next = 8;
          return trendWidget.initMap();
        case 8:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
});
var changeContractMap = function changeContractMap(sale) {
  var mapContainer = document.getElementById("trend-map-container");
  if (sale) {
    trendWidget.priceLayers.forEach(function (layer) {
      trendWidget.map.getMap().addLayer(layer);
    });
    trendWidget.priceLayersRent.forEach(function (layer) {
      trendWidget.map.getMap().removeLayer(layer);
    });
    mapContainer === null || mapContainer === void 0 ? void 0 : mapContainer.classList.remove("rent-active");
    mapContainer === null || mapContainer === void 0 ? void 0 : mapContainer.classList.add("sale-active");
  } else {
    mapContainer === null || mapContainer === void 0 ? void 0 : mapContainer.classList.add("rent-active");
    mapContainer === null || mapContainer === void 0 ? void 0 : mapContainer.classList.remove("sale-active");
    trendWidget.priceLayers.forEach(function (layer) {
      trendWidget.map.getMap().removeLayer(layer);
    });
    trendWidget.priceLayersRent.forEach(function (layer) {
      trendWidget.map.getMap().addLayer(layer);
    });
  }
};
var changeContract = function changeContract(sale, e) {
  e.preventDefault();
  var button = e.currentTarget;
  if (button.classList.contains("option-active")) return;
  //@ts-ignore
  var options = button.parentElement.getElementsByClassName("option-active");
  for (var i = 0; i < options.length; i++) {
    options.item(i).classList.remove("option-active");
  }
  changeContractMap(sale);
  button.classList.add("option-active");
  trendWidget.loading = true;
  trendWidget.sale = sale;
  trendWidget.render();
  trendWidget.loading = false;
  sendGAevent("TREND_WIDGET_INTERACTION", {
    contract_type: trendWidget.sale ? "sale" : "rent",
    period: PERIOD[trendWidget.period],
    place: window["_place"] || "",
    map: trendWidget.showTrendMap,
    map_navigation: trendWidget.showBack
  });
  sendMessageEvent("TREND_WIDGET_INTERACTION", {
    contract_type: trendWidget.sale ? "sale" : "rent",
    period: PERIOD[trendWidget.period],
    place: window["_place"] || "",
    map: trendWidget.showTrendMap,
    map_navigation: trendWidget.showBack
  });
};
var changePeriod = function changePeriod(period, e) {
  e.preventDefault();
  var button = e.currentTarget;
  if (button.classList.contains("option-active")) return;
  //@ts-ignore
  var options = button.parentElement.getElementsByClassName("option-active");
  for (var i = 0; i < options.length; i++) {
    options.item(i).classList.remove("option-active");
  }
  button.classList.add("option-active");
  trendWidget.loading = true;
  trendWidget.period = period;
  sendGAevent("TREND_WIDGET_INTERACTION", {
    contract_type: trendWidget.sale ? "sale" : "rent",
    period: PERIOD[trendWidget.period],
    place: window["_place"] || "",
    map: trendWidget.showTrendMap,
    back: trendWidget.showBack
  });
  sendMessageEvent("TREND_WIDGET_INTERACTION", {
    contract_type: trendWidget.sale ? "sale" : "rent",
    period: PERIOD[trendWidget.period],
    place: window["_place"] || "",
    map: trendWidget.showTrendMap,
    back: trendWidget.showBack
  });
  trendWidget.render();
  trendWidget.loading = false;
};
document.getElementById("period-max").addEventListener("click", function (e) {
  changePeriod(PERIOD.ALL, e);
});
document.getElementById("period-one-year").addEventListener("click", function (e) {
  changePeriod(PERIOD.ONE_YEAR, e);
});
document.getElementById("period-six-months").addEventListener("click", function (e) {
  changePeriod(PERIOD.SIX_MONTHS, e);
});
document.getElementById("period-three-months").addEventListener("click", function (e) {
  changePeriod(PERIOD.THREE_MONTHS, e);
});
document.getElementById("sale-tab").addEventListener("click", function (e) {
  changeContract(true, e);
});
document.getElementById("rent-tab").addEventListener("click", function (e) {
  changeContract(false, e);
});
function hexToRGB(hex) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var r = parseInt(hex.slice(0, 2), 16),
    g = parseInt(hex.slice(2, 4), 16),
    b = parseInt(hex.slice(4, 6), 16);
  return "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(alpha, ")");
}
function getDottedString(price) {
  return Number.parseFloat(price.toFixed(2)).toLocaleString(window["_lang"], {
    minimumFractionDigits: 2
  });
}
function getFullLocaleString(locale) {
  return locale === "it" ? "it-IT" : locale === "en" ? "en-US" : "de-DE";
}